import React from 'react';

const getLegendStyle = (props) => {
    switch(props.legendalign) {
        case "horizontal":
            return {
                display:"inline-block",
                marginRight:"5px"    
            };
        case "vertical":
            return {
                display:"block",
                marginBottom:"5px"
            };
        default:
            return {
                display:"block",
                marginBottom:"5px"
            };
    }    
};
const symbolFromType = function(symboltype,color) {
    return <span style={{
        backgroundColor:color,
        display:"inline-block",
        width:"16px",
        height: symboltype=="bar"||symboltype=="circle"?"16px":"2px",
        marginRight: "3px",
        verticalAlign:"middle",
        borderRadius: symboltype=="circle"?"16px":"0"
    }}></span>
} 

const legendItemFromData = function(data,legendtype,selected,hovered,id,props) {
    if(typeof legendtype === "undefined") {
        legendtype = "line";
    }
    
    let wrapHandler = (func,i) => {
        return () => {
            return func?func(i,...arguments):undefined;
        }
    };
    return <div 
        className={"legenditem" + (selected?" selected":"") + (hovered?" hovered":"")} 
        key={"legend_"+id}
        onMouseOver={wrapHandler(props.onItemMouseOver,id)}
        onMouseEnter={wrapHandler(props.onItemMouseEnter,id)}
        onMouseLeave={wrapHandler(props.onItemMouseLeave,id)}
        onClick={wrapHandler(props.onItemClick,id)}
    >
            {symbolFromType(legendtype,data.color)}
            {data.name}
        </div>
}

export default (props) => {    
    return <div style={{width:"100%"}}>
        <div style={getLegendStyle(props)}
            className={"chartLegend" + (props.selected!=null?" selecting":"") + (props.hovered!=null?" hovering":"")}
        >
            {props.data.map((obj,i) => legendItemFromData(obj,props.symboltype,i==props.selected,i==props.hovered,i,props))}    
        </div>
    </div>
}



// WEBPACK FOOTER //
// ./src/js/components/charting/HtmlLegend/HtmlLegend.jsx